import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AppPublishType, IAppPublishingCdnStatus } from '../abstractions';

interface IAppTypeState {
  appType?: AppPublishType;
}

const initialState: IAppTypeState = {};

export const appTypeSlice = createSlice({
  name: 'appType',
  initialState,
  reducers: {
    getAppPublishTypeSuccess: (
      state,
      { payload }: PayloadAction<IAppPublishingCdnStatus[]>
    ) => {
      const isAppInCDN = payload.some((status) => status.wasAppFound);
      return {
        ...state,
        appType: isAppInCDN ? AppPublishType.CDN_App : AppPublishType.TDP_App,
      };
    },
    getAppPublishTypeFail: (state) => {
      // default to TDP app for existing workflows in case API Fails
      return {
        ...state,
        appType: AppPublishType.TDP_App,
      };
    },
    resetAppPublishTuype: () => initialState,
  },
});
